import {CountryComponent, CountrySelectDirective, CountryService} from './country';

export const DICTIONARY_COMPONENTS = [
    CountryComponent,
    CountrySelectDirective
];

export const DICTIONARY_SERVICES = [
    CountryService
];


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/components/dictionary/index.ts